import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import moment from 'moment';
import './index.css'

import './sentry.ts';

moment.defineLocale('en-au', {
  parentLocale: 'en',
  longDateFormat: {
    L: "DD/MM/YYYY",
    l: "D/M/YYYY",
    LT: "h:mm a",
    LL: "MMMM Do YYYY",
    LTS: "h:mm:ss A",
    ll: "D MMM YYYY",
    LLL: "Do MMMM YYYY LT",
    lll: "D MMM YYYY LT",
    LLLL: "dddd, Do MMMM YYYY LT",
    llll: "ddd, D MMM YYYY LT"
  }
});

createRoot(document.getElementById('root')!).render(
  <App />
)
